import Button from "@/common/components/Button";
import { ChevronLeftIcon } from "lucide-react";

interface CreateForwardingDirectiveEntryFormStepHeaderProps {
  goBackAction?: () => void;
  title: string;
  description?: string;
}

const CreateForwardingDirectiveEntryFormStepHeader = ({
  goBackAction,
  title,
  description,
}: CreateForwardingDirectiveEntryFormStepHeaderProps) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {goBackAction && (
          <Button
            variant="link-white"
            onClick={goBackAction}
          >
            <ChevronLeftIcon size={16} className="text-blue-800" />
          </Button>
        )}

        <p className="text-sm font-bold">
          {title}
        </p>
      </div>

      {description && (
        <p className="text-xs text-white-400">
          {description}
        </p>
      )}
    </div>
  );
}

export default CreateForwardingDirectiveEntryFormStepHeader;
